import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-feb25a8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "distribution-groups-wrapper",
  class: "main-content-wrapper"
}
const _hoisted_2 = { class: "distribution-groups-title grid" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-title col-3 mt-3" }, "タグ配信グループ一覧", -1))
const _hoisted_4 = { class: "distribution-groups-filter grid mt-1" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full pt-2 px-2" }, [
  /*#__PURE__*/_createTextVNode(" ※配信者数が20名以上でないと「開封数/率」「クリック数/率」のデータ取得ができません。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ※配信メッセージに予約リンクを設定していないと「予約完了数/率」「予約キャンセル数/率」のデータは取得できません。"),
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_6 = { class: "d-flex" }
const _hoisted_7 = { class: "col-auto ml-auto mt-2" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "開始日", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-auto to-icon mx-2" }, "~", -1))
const _hoisted_10 = { class: "col-auto mt-2" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "終了日", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-filter" }, null, -1))
const _hoisted_13 = { class: "distribution-groups-list-body mt-3" }
const _hoisted_14 = { class: "grid ml-0" }
const _hoisted_15 = { class: "p-input-icon-left h-auto box-search" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-filter-slash" }, null, -1))
const _hoisted_18 = { class: "list-groups mt-3" }
const _hoisted_19 = { class: "w-full text-right pr-3" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "grid mt-3 justify-content-center" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/images/warning-logo.png",
    alt: "Warning Logo",
    class: "warning-logo mr-4 ml-2"
  }),
  /*#__PURE__*/_createElementVNode("span", null, "これらの配布グループを削除しますか?")
], -1))
const _hoisted_30 = { class: "grid mt-5 mb-5 justify-content-center" }
const _hoisted_31 = { class: "grid mt-5 mb-5 justify-content-center" }

import { ref, onBeforeMount, computed } from "vue";
import { get, set } from "@vueuse/core";
import { useStore } from "vuex";
import { useToast } from "primevue/usetoast";
import { PageState } from "primevue/paginator";
import Toast from "primevue/toast";
import SelectButton from "primevue/selectbutton";
import Calendar from "primevue/calendar";
import Checkbox from "primevue/checkbox";
import Chip from "primevue/chip";
import InputSwitch from "primevue/inputswitch";
import Dialog from "primevue/dialog";
import Paginator from "@/clinic/components/atoms/Paginator/index.vue";
import { notityErrorMsg, notifySuccessMsg } from "@/clinic/utils/notify-utils";
import Grid from "@/clinic/components/atoms/Grid/index.vue";
import { DEFAULT_PAGINATOR_ROWS } from "@/clinic/typings/constants/paginator";
import RouterConstants from "@/clinic/constants/router.constants";
import RouterUtils from "@/common/utils/router.util";
import DistributionGroupService from "@/clinic/services/distribution_group_service";
import moment from "moment";

type IColumn = {
  field: string;
  header: string;
  class?: string;
  style?: string;
  icon?: any;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const first = ref(0);
const rows = ref(DEFAULT_PAGINATOR_ROWS);
const totalCount = ref(0);
const searchTerm = ref("");
const toast = useToast();
const page = ref(0);
const pgTop = ref<InstanceType<typeof Paginator> | null>(null);
const pgBot = ref<InstanceType<typeof Paginator> | null>(null);
const distributionGroups = ref([]);
const warningVisible = ref(false);
const clinicId = ref();
const store = useStore();
const sendImmediateDialog = ref(false);
const currentEditDistributionGroup = ref(false);
const selectedFilter = ref("all");
const filterDayStart = ref(new Date());
const filterDayEnd = ref(new Date());
const loading = ref(false);
const listChosen = ref([]);

const groupType = [
  { label: "すべて", value: "all" },
  { label: "新規向け", value: "new_user" },
  { label: "再来向け", value: "re_examination" },
  { label: "既存向け", value: "existing" },
  { label: "一斉配信", value: "broadcast_all_in_one" },
  { label: "その他", value: "other_type" },
];

const columns = ref<IColumn[]>([
  { field: "action", header: "", class: "col", style: "max-width: 50px" },
  { field: "status", header: "ステータス", class: "col", style: "font-size: 13px; max-width: 75px " },
  { field: "group_type", header: "カテゴリ", class: "col-2", style: "font-size: 13px; max-width: 100px " },
  {
    field: "name",
    header: "配信名",
    class: "col-2",
    style: "font-size: 13px; max-width: 150px ",
  },
  { field: "send_at", header: "配信予定 日時", class: "col", style: "font-size: 13px; max-width: 110px " },
  { field: "delivery_frequency", header: "配信回数", class: "col", style: "font-size: 13px; max-width: 75px " },
  { field: "number_of_delivered", header: "メッセージ 数", class: "col", style: "font-size: 13px; max-width: 60px" },
  { field: "number_of_targets", header: "対象ユー ザー数", class: "col", style: "font-size: 13px; max-width: 62px" },
  { field: "opens_rate", header: "開封数/率", class: "col", style: "font-size: 13px" },
  { field: "clicks_rate", header: "クリック数/率", class: "col", style: "font-size: 13px " },
  { field: "number_completed_on_bookings", header: "予約完了数/率", class: "col", style: "font-size: 13px " },
  {
    field: "number_of_canceled",
    header: "予約キャンセル数 /率",
    class: "col",
    style: "font-size: 13px; max-width: 105px",
  },
  { field: "edit", header: "編集", class: "col" },
]);

const switchClassMapping = {
  active: "active",
  delivered: "delivered",
  delivery_error: "delivery_error",
};

const createWithExistSetting = async () => {
  if (listChosen.value.length == 1) {
    const chosenID = listChosen.value[0];
    RouterUtils.goToWithParams(RouterConstants.DUPLICATE_DISTRIBUTION_GROUP_ROUTER_NAME, { id: chosenID });
  } else if (listChosen.value.length == 0) {
    notityErrorMsg(toast, "配信グループを選択してください");
  } else if (listChosen.value.length > 1) {
    notityErrorMsg(toast, "配送グループを 1 つだけ選択してください");
  }
};

const openPopUpWarningBroadCast = (event, templateId) => {
  event.stopPropagation();
  sendImmediateDialog.value = true;
  currentEditDistributionGroup.value = templateId;
};

const handleError = promise => {
  return promise.then(data => [undefined, data]).catch(error => [error, undefined]);
};

const onOpenChangeStatusDialog = async (data: any) => {
  if (data.status == "active") {
    const params = { clinic_id: clinicId.value };
    const body = { status: "stop" };

    const [errorSaveDraft, response] = await handleError(DistributionGroupService.changeStatus(data.id, params, body));
    if (errorSaveDraft) {
      notityErrorMsg(toast, "エラーが発生しました");
    } else {
      notifySuccessMsg(toast, "指定の配信グループの配信を停止しました");
      loadDistributionGroups();
    }
  }
};

const onClearFilter = async () => {
  set(selectedFilter, "all");
  set(filterDayStart, new Date());
  set(filterDayEnd, new Date());
  set(searchTerm, "");
  set(page, 0);
  set(first, 0);
  await loadDistributionGroups();
};

const onSendMessageImmediately = async () => {
  set(warningVisible, false);

  const body = { delivery_type: "immediate_delivery" };
  const params = { clinic_id: clinicId.value };
  const [errorUpdateDeliveryType, response] = await handleError(
    DistributionGroupService.updateDeliverySettings(currentEditDistributionGroup.value, params, body)
  );
  if (errorUpdateDeliveryType) {
    notityErrorMsg(toast, "エラーが発生しました");
  } else {
    const [errorBroadCast, data] = await handleError(
      DistributionGroupService.broadcast(currentEditDistributionGroup.value, params)
    );
    if (errorBroadCast) {
      notityErrorMsg(toast, "この配布グループをブロードキャストするときにエラーが発生しました");
    } else {
      notifySuccessMsg(toast, "この配布グループは正常に配信されました");
    }
  }
  sendImmediateDialog.value = false;
  loadDistributionGroups();
};

const onSearch = async () => {
  set(page, 0);
  set(first, 0);
  await loadDistributionGroups();
};

const onDateFilter = async () => {
  set(page, 0);
  set(first, 0);
  await loadDistributionGroups(true);
};

const onFilterChange = async () => {
  set(page, 0);
  set(first, 0);
  await loadDistributionGroups();
};

const paginatorParams = computed(() => {
  const params = {
    term: get(searchTerm),
    page: get(page) + 1, // APIは1ベースのページ番号を期待
    rows: get(rows),
    status: ["active", "delivered", "delivery_error"],
    group_type: get(selectedFilter) == "all" ? [] : [get(selectedFilter)],
  };
  return params;
});

const paging = async (fromId: string, { page: newPage }: PageState) => {
  if (newPage === page.value) return;

  // ページ番号の範囲チェック
  const totalPages = Math.ceil(get(totalCount) / get(rows));
  if (newPage < 0 || newPage >= totalPages) {
    console.warn(`無効なページ番号: ${newPage}, 総ページ数: ${totalPages}`);
    return;
  }

  set(page, newPage);
  const filterDate =
    moment(filterDayStart.value).format("YYYY-MM-DD") == moment(filterDayEnd.value).format("YYYY-MM-DD") ? false : true;
  await loadDistributionGroups(filterDate);
};

const goToNewDistributionGroup = () => {
  RouterUtils.goTo(RouterConstants.NEW_DISTRIBUTION_GROUPS_NAME);
};

const goToDraftLists = () => {
  RouterUtils.goTo(RouterConstants.DISTRIBUTION_GROUPS_DRAFTS_NAME);
};

const editDistribution = (event, templateId) => {
  event.stopPropagation();
  RouterUtils.goToWithParams(RouterConstants.EDIT_DISTRIBUTION_GROUP_ROUTER_NAME, { id: templateId });
};

const loadDistributionGroups = async (filterTime?: boolean) => {
  try {
    set(loading, true);
    const immediate_delivery_type = 1;
    const specific_time_delivery_type = 2;
    const delivery_type = [immediate_delivery_type, specific_time_delivery_type];
    const sendAtStart = filterTime ? moment(filterDayStart.value).format("YYYY-MM-DD HH:mm") : undefined;
    const sendAtEnd = filterTime ? moment(filterDayEnd.value).format("YYYY-MM-DD HH:mm") : undefined;
    const params = {
      clinic_id: clinicId.value,
      delivery_type: delivery_type,
      send_at_start: sendAtStart,
      send_at_end: sendAtEnd,
      ...get(paginatorParams),
    };
    const { data } = await DistributionGroupService.getDistributionGroups(params);

    const { distribution_groups: distributionGroupsData, meta } = get(data);
    const { total_count } = meta;
    set(distributionGroups, distributionGroupsData);
    set(totalCount, get(total_count));
  } catch (error) {
    console.error("配信グループ取得エラー:", error);
    // エラーが発生した場合は現在のページを維持し、データは変更しない
  } finally {
    set(loading, false);
  }
};

const deleteDistributionGroup = async () => {
  await DistributionGroupService.destroyDistributionGroups(
    listChosen.value,
    () => {
      notifySuccessMsg(toast, "指定された配布グループが除外されました");
      loadDistributionGroups();
    },
    () => notityErrorMsg(toast, "エラーが発生しました")
  );
  set(warningVisible, false);
};

const loadClinicInfo = async () => {
  const storeClinicId = await store.dispatch("authClient/getClinicIdCookie");
  clinicId.value = storeClinicId;
};

const onCheckDelete = () => {
  const chosenGroups = distributionGroups.value.filter(distributionGroup =>
    listChosen.value.includes(distributionGroup.id)
  );
  if (
    chosenGroups.some(
      distributionGroup => distributionGroup.status == "delivered" || distributionGroup.status == "delivery_error"
    )
  ) {
    notityErrorMsg(toast, "送信済グループは削除できません");
  } else {
    warningVisible.value = true;
  }
};
onBeforeMount(async () => {
  await loadClinicInfo();
  await loadDistributionGroups();
});

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_Button, {
          class: "col-auto ml-auto temp-save-btn mt-3",
          label: "下書保存再編集",
          onClick: goToDraftLists
        }),
        _createVNode(_component_Button, {
          class: "col-auto mt-3 create-btn ml-3 mb-2",
          label: "配信グループ新規作成",
          onClick: goToNewDistributionGroup
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_unref(SelectButton), {
          modelValue: selectedFilter.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedFilter).value = $event)),
          options: groupType,
          optionLabel: "label",
          optionValue: "value",
          class: "mt-5 ml-2",
          onChange: onFilterChange,
          unselectable: selectedFilter.value.length === 0
        }, null, 8, ["modelValue", "unselectable"]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_unref(Calendar), {
              modelValue: filterDayStart.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filterDayStart).value = $event)),
              class: "justify-content-end filter-calendar mt-1",
              showIcon: "",
              dateFormat: "yy/mm/dd"
            }, null, 8, ["modelValue"])
          ]),
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_unref(Calendar), {
              modelValue: filterDayEnd.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filterDayEnd).value = $event)),
              class: "justify-content-end filter-calendar mt-1",
              showIcon: "",
              dateFormat: "yy/mm/dd"
            }, null, 8, ["modelValue"])
          ]),
          _createVNode(_component_Button, {
            class: "black-btn ml-3 mt-5",
            onClick: onDateFilter
          }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("span", _hoisted_15, [
            _hoisted_16,
            _createVNode(_component_InputText, {
              placeholder: "配信名",
              onKeyup: _withKeys(onSearch, ["enter"]),
              modelValue: searchTerm.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((searchTerm).value = $event))
            }, null, 8, ["onKeyup", "modelValue"])
          ]),
          _createVNode(_component_Button, {
            class: "black-btn ml-3",
            onClick: _cache[4] || (_cache[4] = async () => await onClearFilter())
          }, {
            default: _withCtx(() => [
              _hoisted_17
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_18, [
          (totalCount.value > rows.value)
            ? (_openBlock(), _createBlock(Paginator, {
                key: 0,
                id: "pg-top",
                ref_key: "pgTop",
                ref: pgTop,
                modelValue: first.value,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((first).value = $event)),
                onPaging: paging,
                totalRecords: totalCount.value,
                rows: rows.value
              }, null, 8, ["modelValue", "totalRecords", "rows"]))
            : _createCommentVNode("", true),
          _createVNode(Grid, {
            items: distributionGroups.value,
            columns: columns.value,
            loading: loading.value
          }, {
            action: _withCtx(({ data }) => [
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_unref(Checkbox), {
                  modelValue: listChosen.value,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((listChosen).value = $event)),
                  inputId: data.id,
                  name: data.id,
                  value: data.id
                }, null, 8, ["modelValue", "inputId", "name", "value"])
              ])
            ]),
            status: _withCtx(({ data }) => [
              _createElementVNode("div", {
                class: _normalizeClass(["form-check form-switch", switchClassMapping[data.status]])
              }, [
                _createVNode(_unref(InputSwitch), {
                  trueValue: data.status == 'active',
                  onChange: () => onOpenChangeStatusDialog(data)
                }, null, 8, ["trueValue", "onChange"])
              ], 2)
            ]),
            group_type: _withCtx(({ data }) => [
              _createVNode(_unref(Chip), {
                label: groupType.find(item => item.value == data.group_type)?.label
              }, null, 8, ["label"])
            ]),
            send_at: _withCtx(({ data }) => [
              (data.send_at != null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_unref(moment)(data.send_at).locale("ja").format("YYYY年MM月DD日 HH:mm")), 1))
                : _createCommentVNode("", true)
            ]),
            opens_rate: _withCtx(({ data }) => [
              (data.number_of_opens != null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(data.number_of_opens) + "/" + _toDisplayString(data.opened_rate) + "%", 1))
                : _createCommentVNode("", true)
            ]),
            clicks_rate: _withCtx(({ data }) => [
              (data.number_of_clicks != null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(data.number_of_clicks) + "/" + _toDisplayString(data.click_rate) + "%", 1))
                : _createCommentVNode("", true)
            ]),
            number_completed_on_bookings: _withCtx(({ data }) => [
              (data.number_of_completed_reservations != null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(data.number_of_completed_reservations) + "/" + _toDisplayString(data.completed_reservations_rate) + "% ", 1))
                : _createCommentVNode("", true)
            ]),
            number_of_canceled: _withCtx(({ data }) => [
              (data.number_of_reservation_cancellations != null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(data.number_of_reservation_cancellations) + "/" + _toDisplayString(data.reservation_cancellations_rate) + "% ", 1))
                : _createCommentVNode("", true)
            ]),
            edit: _withCtx(({ data }) => [
              (data.status == 'active')
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _createElementVNode("span", {
                      class: "pi pi-pencil text-green-600 mr-5",
                      onClick: ($event: any) => (editDistribution($event, data.id))
                    }, null, 8, _hoisted_26),
                    _createElementVNode("span", {
                      class: "pi pi-envelope text-yellow-500",
                      onClick: ($event: any) => (openPopUpWarningBroadCast($event, data.id))
                    }, null, 8, _hoisted_27)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["items", "columns", "loading"]),
          _createVNode(Paginator, {
            id: "pg-bot",
            ref_key: "pgBot",
            ref: pgBot,
            modelValue: first.value,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((first).value = $event)),
            onPaging: paging,
            totalRecords: totalCount.value,
            rows: rows.value,
            class: "mt-2"
          }, null, 8, ["modelValue", "totalRecords", "rows"]),
          _createVNode(_unref(Toast), { position: "top-center" })
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createVNode(_component_Button, {
            class: "col-2 black-btn ml-5",
            label: "削除",
            onClick: onCheckDelete
          }),
          _createVNode(_component_Button, {
            class: "col-2 create-btn ml-5",
            label: "条件を流用して新規作成",
            onClick: createWithExistSetting
          }),
          _createVNode(_component_Button, {
            class: "col-2 create-btn ml-5",
            label: "配信グループ新規作成",
            onClick: goToNewDistributionGroup
          })
        ])
      ])
    ]),
    _createVNode(_unref(Dialog), {
      visible: warningVisible.value,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((warningVisible).value = $event)),
      modal: "",
      style: { width: '550px' },
      class: "mx-5 dialog-note border-0",
      draggable: false
    }, {
      header: _withCtx(() => [
        _hoisted_29
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_30, [
          _createVNode(_component_Button, {
            class: "col-4 black-btn ml-5",
            label: "戻る",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (warningVisible.value = false))
          }),
          _createVNode(_component_Button, {
            class: "col-4 confirm-delete-btn ml-5",
            label: "確認する",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (deleteDistributionGroup()))
          })
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(Dialog), {
      visible: sendImmediateDialog.value,
      "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((sendImmediateDialog).value = $event)),
      modal: "",
      header: 'メッセージを今すぐ送信してもよろしいですか?',
      class: "mx-5 dialog-note border-0",
      draggable: false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_31, [
          _createVNode(_component_Button, {
            class: "col-3 black-btn ml-5",
            label: "戻る",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (sendImmediateDialog.value = false))
          }),
          _createVNode(_component_Button, {
            class: "col-3 create-btn ml-5 w-fit-content",
            label: "配信再開",
            onClick: onSendMessageImmediately
          })
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(Toast), { position: "top-center" })
  ], 64))
}
}

})